<template>
  <div class="re-comments-wrap">
    <div class="re-comments" v-loading="loading">
      <re-single
        v-for="item in comments"
        :key="`re-comment-${item.id}`"
        :comment='item'
        :post="post"
        :re-comment="true"
        @setTrust="setTrust"
      />
    </div>
  </div>
</template>

<script>
  // components
  import ReSingle from './ReSingle';

  import { getChildComments } from '../../../../../../../api/publications';
  // api
  import { setCommentTrustApi } from '@/api/publications';

  export default  {
    name: 'ReComment',
    props: {
      post: {
        type: Object
      },
      comment: {
        type: Object
      }
    },
    data() {
      return {
        loading: false,
        start: 0,
        limit: 20,
        comments: [],
      };
    },
    methods: {
      setTrust({trust, commentId}) {
        const params = {
          comment_id: commentId,
          post_id: this.post.id,
          owner_id: this.post.owner_id,
          network_id: this.post.network_id,
          trust: trust
        };

        setCommentTrustApi(params).then(() => {
          this.comments = this.comments.map(item => {
            if (item.id === commentId) {
              item.trust_coment = trust;
            }

            return item;
          });
        });
      },
      getChildComments() {
        let params = {
          thread_id: this.$route.params.threadId,
          start: this.start,
          limit: this.limit,
          post_id: this.post.id,
          owner_id: this.comment.owner_id,
          comment_id: this.comment.id,
          network_id: this.comment.network_id
        };

        getChildComments(params).then((resp) => {
          this.comments = [...this.comments, ...resp.data.commentaries];
          this.start = this.start + resp.data.commentaries.length;
        });
      }
    },
    components: {
      ReSingle,
    },
    mounted() {
      this.getChildComments();
    }
  };
</script>

<style>
  .re-comments {
    box-sizing: border-box;
    margin-bottom: -20px;
    width: 100%;
    border-top: 1px solid #ebebeb;
    background-color: #F5F7FA;
  }
</style>
